import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { DocumentFacade } from "../../document-states/document.facade";

@Component({
  selector: "cradua-document-container",
  templateUrl: "./document-container.component.html",
  styleUrls: ["./document-container.component.scss"],
})
export class DocumentContainerComponent implements OnInit {
  completed$: Observable<boolean>;
  progress$: Observable<number>;
  error$: Observable<string>;
  isInProgress$: Observable<boolean>;
  isReady$: Observable<boolean>;
  hasFailed$: Observable<boolean>;

  constructor(
    private documentFacade: DocumentFacade,
  ) {}

  ngOnInit() {
    this.completed$ = this.documentFacade.completed();

    this.progress$ = this.documentFacade.progress();

    this.error$ = this.documentFacade.error();

    this.isInProgress$ = this.documentFacade.isInProgress();

    this.isReady$ = this.documentFacade.isReady();

    this.hasFailed$ = this.documentFacade.hasFailed();
  }

  uploadFile(file: any) {
    // const files: FileList = event.target.files;
    // const file = files.item(0);

    this.documentFacade.uploadDocumentWithFile("document", file);

    // clear the input form
    // event.srcElement.value = null;
  }

  resetUpload(value) {
    this.documentFacade.resetUpload();
  }

  cancelUpload(value) {
    this.documentFacade.cancelUpload();
  }
}
